export default __webpack_public_path__ + "static/keyrus-intro-fa3339222044e132ea9ff4e8ae61f47b.mp4";